import React from 'react';
import CountUp from 'react-countup';

const HeroBox = () => {
  return (
    <section className="px-4 py-8 bg-white relative">
      <div className="max-w-6xl w-full mx-auto flex flex-col md:flex-row shadow-shadow-1 rounded-xl overflow-hidden -mt-28 md:-mt-44 bg-white">
        {/* Left Panel */}
        <div className="bg-primary p-4 md:p-8 md:w-[40%]">
          <p className='text-white text-base md:text-lg leading-7 font-light text-center'>
            <span className='font-bold'>
              Tuber eliminates the hassle by delivering what you need—fast.
            </span> Time is money, and every wasted trip to a trade store costs your business productivity. Stopping
            mid-job to pick up supplies means delayed projects, frustrated clients, and lost revenue.
          </p>
        </div>

        {/* Right Stats Panel */}
        <div className="grid grid-cols-2 text-center p-4 md:p-8 flex-1">
          <div className='pb-4 md:pb-8 border-b border-r border-gray-300'>
            <h2 className="text-2xl md:text-4xl font-bold text-headings mb-2">
              <CountUp end={800} duration={2} />+
            </h2>
            <p className="text-light_black text-sm md:text-base">Registered Drivers</p>
          </div>

          <div className='pb-4 md:pb-8 border-b border-gray-300'>
            <h2 className="text-2xl md:text-4xl font-bold text-headings mb-2">
              <CountUp end={98.1} duration={2} decimals={1} />%
            </h2>
            <p className="text-light_black text-sm md:text-base">Delivered on Time</p>
          </div>

          <div className='pt-4 md:pt-8 border-r border-gray-300'>
            <h2 className="text-2xl md:text-4xl font-bold text-headings mb-2">
              <CountUp end={1} duration={2} /> Min
            </h2>
            <p className="text-light_black text-sm md:text-base">Average Response Time</p>
          </div>

          <div className='pt-4 md:pt-8'>
            <h2 className="text-2xl md:text-4xl font-bold text-headings mb-2">
              <CountUp end={150} duration={2} />+
            </h2>
            <p className="text-light_black text-sm md:text-base">Business Customers</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBox;
